module.exports = __webpack_public_path__ + "img/shoutout.dc0eae8f.svg";